import classNames from 'classnames';

import { CoreGlobalNavigationHeaderData } from 'src/types/components';

import TextCTA from 'components/BaseHelpers/TextCTA';

import styles from './AncillaryNavigation.module.scss';

type OwnProps = {
  className?: string;
};

export type AncillaryNavigationProps = OwnProps &
  CoreGlobalNavigationHeaderData['fields']['ancillaryNavigation'];

const AncillaryNavigation = ({ className, links }: AncillaryNavigationProps): JSX.Element => {
  return (
    <nav className={classNames(className, styles.nav)}>
      <ul className={styles.list}>
        {links.map((link, index) => {
          return (
            <li className={styles.item} key={index}>
              <TextCTA size="small" tag="a" {...link} />
            </li>
          );
        })}
      </ul>
    </nav>
  );
};

export default AncillaryNavigation;
